import { ElementPageSection, TemplateSection } from "@/services/admin-services/models";
import { DataTableData, DataTableFootnote } from "../DataTable/Models";
import { Section } from "./Models";

export const toViewerSection = (
    template: TemplateSection,
    sections: ElementPageSection[],
    footnotes: DataTableFootnote[]
) => {
    switch (template.sectionType) {
        case "page-section-header":
            try {
                return { ...template, content: JSON.parse(template.content) } as Section;
            } catch {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return { ...template, content: { text: template.content } as any } as Section;
            }

        case "page-static-content":
            return { ...template, content: JSON.parse(template.content) } as Section;

        case "content-editor": {
            const editor = { ...template } as Section;
            const savedEditor = sections?.find((x) => x.sectionCode === template.sectionCode);

            if (!savedEditor) return editor;

            editor.content = savedEditor.content ? JSON.parse(savedEditor.content) : undefined;

            return editor;
        }

        case "ids-platform-table-ifc":
        case "ids-platform-table-gid-geometry":
        case "ids-platform-table-gid-information":
        case "ids-platform-table-gid-documentation":
        case "ids-platform-table-classification": {
            const table = {
                ...template,
                config: JSON.parse(template.content),
                content: { rows: [], footnotes: [], caption: "" },
            } as Section;
            const savedTable = sections?.find((x) => x.sectionType === template.sectionType);

            if (savedTable) {
                table.content = (
                    savedTable.content ? JSON.parse(savedTable.content) : { rows: [], footnotes: [], caption: "" }
                ) as DataTableData;

                if (footnotes && footnotes.length > 0) {
                    const tableFootnotes = (table.content as DataTableData).footnotes.filter(
                        (x) => !footnotes.find((y) => y.id === x.id)
                    );

                    table.content.footnotes = [...tableFootnotes, ...footnotes];
                }
            }

            return table;
        }

        default:
            throw new Error("Invalid section type detected.");
    }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const toEditorSection = (template: TemplateSection, sections: any[]) => {
    switch (template.sectionType) {
        case "page-section-header":
            return template as Section;

        case "page-static-content":
            return { ...template, content: JSON.parse(template.content) } as Section;

        case "content-editor": {
            const editor = { ...template } as Section;
            const savedEditor = sections?.find((x) => x.sectionCode === template.sectionCode);

            if (savedEditor) {
                editor.content = savedEditor.content ? JSON.parse(savedEditor.content) : undefined;
                savedEditor.content = savedEditor.content ? JSON.parse(savedEditor.content) : undefined;
            }

            return editor;
        }

        case "ids-platform-table-ifc":
        case "ids-platform-table-gid-geometry":
        case "ids-platform-table-gid-information":
        case "ids-platform-table-gid-documentation":
        case "ids-platform-table-classification": {
            const table = {
                ...template,
                config: JSON.parse(template.content),
                content: { rows: [], footnotes: [], caption: "" },
            } as Section;
            const savedTable = sections?.find((x) => x.sectionType === template.sectionType);

            if (savedTable) {
                table.content = savedTable.content
                    ? JSON.parse(savedTable.content)
                    : { rows: [], footnotes: [], caption: "" };
                savedTable.content = savedTable.content
                    ? JSON.parse(savedTable.content)
                    : { rows: [], footnotes: [], caption: "" };
            }

            return table;
        }

        default:
            throw new Error("Invalid section type detected.");
    }
};
